import type { ReactNode } from 'react'

import * as styles from './OngoingCallDialog.css'

interface OngoingCallDialogProps {
  children?: ReactNode
  'aria-label'?: string
}

function OngoingCallDialog({ children, ...props }: OngoingCallDialogProps) {
  return (
    <div role="dialog" aria-label={props['aria-label']} className={styles.root}>
      {children}
    </div>
  )
}

export default OngoingCallDialog
